import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';

export const selectOptionSchema = z.object({
    /** The human-readable label shown to the user */
    label: z.string(),
    /** The value written to the target variable when this option is selected */
    value: z.string(),
});

export const selectCellAttrsSchema = cellCfgAttrsBaseSchema.extend({
    /** Label displayed above the select control */
    label: z.string(),
    /** The variable to write the selected option's value to */
    writeVarId: z.string().min(1),
    /** The list of options available to the user */
    options: z.array(selectOptionSchema).default([]),
    /** Whether the user can clear the selection (writes null to the variable) */
    clearable: z.boolean().default(false),
    /** Controls whether the select is interactive. Falsy (0 or empty string) disables it. Can be driven by a modifier variable. */
    enabled: z.union([ z.number(), z.string() ]),
});

export const selectCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('select'),
    attrs: selectCellAttrsSchema,
    modifiers: z.record(z.enum([
        'enabled',
        'label',
    ]), z.string().optional()).optional(),
});
